//--------------------------------------------------------------------------
// <copyright file="FluentPrimaryButton.js" company="Microsoft">
// Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------
import React, { useState } from 'react'
import { Dropdown, PrimaryButton } from '@fluentui/react';

/// <summary>
/// Wrapper over the primary button from microsoft fluent library.
/// </summary>
const FluentDropdown = ({ setSelectedOption, selectedOption }) => {

  const options = JSON.parse(process.env.REACT_APP_OPTIONS);

  const dropdownStyles = {
    dropdown: { width: '352px', marginLeft: '44px', marginBottom: '15px', selectors: { ':focus:after': { borderTop: '0px', borderLeft:'0px', borderRight:'0px'  } }  },
    title: { borderTop:'0px', borderLeft:'0px', borderRight:'0px' },
  };

  const dropdownIconProps = { iconName: 'ChevronDown' };


  const handleDropdownChange = (event, option) => {
    setSelectedOption(option);
  }

  return (
    <div>
      <Dropdown aria-label="select region list" data-testid="dropdown" cssClassName="Dialog-dropdown" placeholder="Select region" options={options} styles={dropdownStyles} iconProps={dropdownIconProps} onChange={handleDropdownChange}/>
    </div>
  )
}

export default FluentDropdown